import { isLoading, Loading } from "../Loading";
import { VisitInstanceDetails } from "../messages/Visit";
import useDirections from "./useDirections";

interface Props {
  visitInstance: VisitInstanceDetails | Loading;
}

const useVisitInstanceDirections = (props: Props) => {
  const { openLocation, closeLocation, directionsState } = useDirections();

  const openVisitInstanceLocation = () => {
    if (isLoading(props.visitInstance)) {
      throw new Error("Can't open visit instance location while visit instance is loading");
    }

    openLocation(props.visitInstance.confidentialVisitDetails.patientAddress);
  };

  return {
    openLocation: openVisitInstanceLocation,
    closeLocation: closeLocation,
    directionsState: directionsState,
  };
};

export default useVisitInstanceDirections;
